module.exports = __webpack_public_path__ + "img/avatar0.f2cf5f33.png";